module.exports = __webpack_public_path__ + "static/media/logo1.96532d90.png";